import { Box, Flex } from '@chakra-ui/layout'
import { View } from '@react-pdf/renderer'

type TitleWithHorizontalLinesProps = {
  children: React.ReactNode
  type: 'builder' | 'pdf'
  template: boolean | undefined
}

const horizontalLinesStyle = {
  width: 40,
  height: 3.5,
  backgroundColor: '#fff',
  marginTop: 600,
}

export const TitleWithHorizontalLines: React.FC<TitleWithHorizontalLinesProps> =
  ({ children, type = 'builder', template = false }) => {
    if (!template) {
      return <>{children}</>
    }

    if (type === 'builder') {
      return (
        <Flex alignItems="center" justifyContent="center">
          <Box w={12} h={0.5} bg="#ffffff" mr={3.5} />
          {children}
          <Box w={12} h={0.5} bg="#ffffff" ml={3.5} />
        </Flex>
      )
    }

    if (type === 'pdf') {
      return (
        <View
          style={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <View
            style={{
              ...horizontalLinesStyle,
              marginRight: 12,
            }}
          />
          {children}
          <View
            style={{
              ...horizontalLinesStyle,
              marginLeft: 12,
            }}
          />
        </View>
      )
    }

    return null
  }
